import * as React from 'react'
import { Route, Switch } from 'react-router'

import Layout from './components/layout/Layout'
import OrderFormContainer from './components/contest/OrderFormContainer'
import withMUI from './withMUI'
import withStripeProvider from './withStripeProvider'

const App: React.SFC = () => (
  <Layout>
    <Switch>
      <Route path="/:contestSlug" component={OrderFormContainer} />
    </Switch>
  </Layout>
)

export default withStripeProvider(withMUI(App))



// WEBPACK FOOTER //
// ./src/App.tsx